export default __webpack_public_path__ + "static/media/blueMarker.8bf04d31.svg";